module.exports = __webpack_public_path__ + "img/shfs-active.a5ea5977.svg";